export const alertStatusDescriptionMap = {
  SUCCESS: "You're all set to start Launching Environments",
  EXPIRED:
    'Looks like you have been timed out, please create a new subscription.',
};

export const alertStatusTitleMapping = {
  SUCCESS: 'Account is linked successfully',
  FAILED: 'Failed to link account',
  EXPIRED: 'Account subscription timed out',
};

export const scriptLinkMap = {
  AZURE: {
    scriptOne:
      'https://facets-cloud.github.io/facets-schemas/scripts/azure-account-link.sh',
    scriptTwo: 'azure-account-link.sh',
  },
  GCP: {
    scriptOne:
      'https://facets-cloud.github.io/facets-schemas/scripts/gcp-account-link.sh',
    scriptTwo: 'gcp-account-link.sh',
  },
  AWS: {
    scriptOne:
      'https://facets-cloud.github.io/facets-schemas/scripts/aws-account-link.sh',
    scriptTwo: 'aws-account-link.sh',
  },
  KUBERNETES: {
    scriptOne:
      'https://facets-cloud.github.io/facets-schemas/scripts/link-k8s-acc.sh',
    scriptTwo: 'link-k8s-acc.sh',
  },
};

export const cloudShellLinkMap = {
  AWS: 'https://ap-south-1.console.aws.amazon.com/cloudshell/home?region=ap-south-1#e8a9b144-b70c-468d-be1e-fd0249123b16',
  AZURE: 'https://portal.azure.com/#cloudshell/',
  GCP: 'https://console.cloud.google.com/welcome?project=facets-cp-test&cloudshell=true--',
};
